export default __webpack_public_path__ + "static/media/sanitizer.6739799e.jpg";